export default __webpack_public_path__ + "static/media/paintdot-membership-details.2a71ad00.jpg";